import { ThemeDefinition } from './types';

export const kindlyTheme: ThemeDefinition = {
  id: 'kindly',
  name: 'Kindly Human',
  colors: {
    'footer-bg': '66, 141, 255' /* #428DFF */,
    'button-primary': '60, 135, 255' /* #3C87FF */,
    'button-primary-hover': '54, 98, 227' /* #3662E3 */,
    'button-secondary': '243, 243, 250' /* #f3f3fa */,
    'button-secondary-hover': '233, 233, 242' /* #e9e9f2 */,
    'peer-details-bg': '132, 214, 255' /* #84D6FF */,
    primary: '0, 34, 119' /* #002277 */,
    'primary-dark': '0, 35, 91' /* #00235B */,
    'profile-circle': '80, 133, 247' /* #5085F7 */,
    'profile-circle-hover': '68, 113, 210' /* #4471D2 */,
    'profile-gradient-start': '60, 135, 255' /* #3C87FF */,
    'profile-gradient-end': '132, 214, 255' /* #84D6FF */,
    'connect-bg': '132, 214, 255' /* #84D6FF */,
    'connect-bg-hover': '214, 235, 255' /* #D6EBFF */,
    'see-more': '197, 229, 244' /* #C5E5F4 */,
    'see-more-hover': '172, 214, 233' /* #ACD6E9 */,
    pill: '199, 225, 252' /* #C7E1FC */,
    accent: '255, 129, 91' /* #ff815b */,
    'arrow-disabled': '179, 179, 179' /* #B3B3B3 */,
    black: '0, 0, 0',
    white: '255, 255, 255',
    'gray-light': '245, 245, 245' /* #F5F5F5 */,
    'progress-bar-gray': '217, 217, 217' /* #d9d9d9 */,
    'input-border-gray': '229, 231, 235' /* #e5e7eb */,
    'placeholder-gray': '106, 114, 130' /* #6a7282 */,
    'muted-text-gray': '94, 94, 121' /* #5e5e79 */,
    'body-gray': '74, 85, 101' /* #4A5565 */,
    'label-gray': '16, 24, 40' /* #101828 */,
    'avatar-border-slate': '202, 213, 226' /* #CAD5E2 */,
    'section-header-slate': '98, 116, 142' /* #62748E */,
    'icon-slate': '144, 161, 185' /* #90A1B9 */,
    'link-light': '207, 225, 255' /* #CFE1FF */,
    error: '199, 0, 54' /* #c70036 */,
    /* Status / UI */
    success: '0, 201, 80' /* #00c950 */,
    'success-hover': '0, 184, 72' /* #00b848 */,
    unavailable: '203, 203, 203' /* #cbcbcb */,
    'selected-border': '0, 78, 203' /* #004ecb */,
    'selected-bg': '240, 244, 255' /* #f0f4ff */,
    'accent-hover': '226, 107, 71' /* #e66b47 */,
    /* Landing */
    'landing-cream': '247, 241, 232' /* #F7F1E8 */,
    'landing-off-white': '253, 249, 243' /* #FDF9F3 */,
    'landing-border': '238, 235, 231' /* #EEEBE7 */,
    'slate-hover': '87, 97, 118' /* #576176 */,
    /* Connect by Goal topic cards */
    'topic-card-divider': '143, 181, 255' /* #8FB5FF - underline */,
    'topic-card-icon-1': '127, 142, 188' /* #7F8EBC */,
    'topic-card-icon-2': '190, 219, 255' /* #BEDBFF */,
  },
};
